"use strict";
'use es6';
/* eslint-disable no-console */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Logger =
/*#__PURE__*/
function () {
  function Logger() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isJasmine = _ref.isJasmine,
        isJasmine = _ref$isJasmine === void 0 ? false : _ref$isJasmine;

    (0, _classCallCheck2.default)(this, Logger);
    this.isJasmine = isJasmine;
  }

  (0, _createClass2.default)(Logger, [{
    key: "reportToSentry",
    value: function reportToSentry(args, context) {
      var message = args.map(function (arg) {
        return arg.toString();
      }).join(' ');
      var baseContext = {
        appVersion: 'v2'
      };
      window.Raven.captureMessage(message, Object.assign({}, baseContext, context));
    }
  }, {
    key: "logServiceError",
    value: function logServiceError(xhr) {
      for (var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      this.error.apply(this, message.concat(["Status " + xhr.status + " " + xhr.statusText + ".", "Response: " + xhr.responseText]));
    }
  }, {
    key: "error",
    value: function error() {
      var _console;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_console = console).error.apply(_console, args.concat(['(reported to Sentry)']));

      this.reportToSentry(args);
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console2;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_console2 = console).warn.apply(_console2, args.concat(['(reported to Sentry)']));

      this.reportToSentry(args, {
        level: 'warning'
      });
    } // These warnings are not fired in the `isJasmine` env because they
    // would be misleading there. Use this sparingly.

  }, {
    key: "warnInApp",
    value: function warnInApp() {
      if (this.isJasmine) {
        return;
      }

      this.warn.apply(this, arguments);
    }
  }, {
    key: "log",
    value: function log() {
      var _console3;

      (_console3 = console).log.apply(_console3, arguments);
    }
  }, {
    key: "debug",
    value: function debug() {
      // `console.debug` is an alias of `console.log`.
      console.warn('`Logger.debug` is an alias of `Logger.log`.', 'Please use that instead.');
      this.log.apply(this, arguments);
    }
  }, {
    key: "info",
    value: function info() {
      var _console4;

      (_console4 = console).info.apply(_console4, arguments);
    }
  }]);
  return Logger;
}();
/* eslint-enable no-console */


exports.default = Logger;
module.exports = exports.default;